'use client';

import { useEffect } from 'react';
import { useUserLogged } from '@/hooks/useUserLogged';
import { clearAccessToken } from '@/lib/httpAdapter';

/**
 * Client component that automatically syncs the user's access token with the HTTP adapter
 * This component should be placed in the root layout to enable automatic auth headers
 */
export default function HttpAdapterProvider() {
  const { status } = useUserLogged();

  useEffect(() => {
    if (status === 'unauthenticated') {
      // Clear the access token when user is not authenticated
      clearAccessToken();
    }
  }, [status]);

  // This component doesn't render anything, it just manages the HTTP adapter
  return null;
}
